<div class="ne-font-picker" data-test-component="font-chooser">
  <Header close="{() => store.set($store.showFontModal.toggle())}" logoSrc={$theme.logoSrc.state} />

  <Title>
    Choose a font
  </Title>

  <Fonts let:font={font}>
    <Font
      fontFamily="{font.family.state}"
      fontWeight="{font.weight.state}"
      isSelected="{chosenFontFace.family.state === font.family.state}"
      onSelect="{() => { chosenFontFace = font }}"/>
  </Fonts>


  <div class="ne-button-container">
    <PrimaryButton trackingId='use message' buttonId='submit-font' click="{choose}">
      Use this font
    </PrimaryButton>
  </div>
</div>

<style>
  .ne-button-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: .5em;
  }

  .ne-font-picker {
    padding: 1em;
    background-color: #fff;
    display: block;
    position: relative;
    z-index: 1;
    max-height: 100%;
  }
</style>

<script>
  import Title from './Title.html';
  import PrimaryButton from './PrimaryButton.html';
  import Messages from './Messages.html';
  import Header from './Header.html';
  import Fonts from './Fonts.html';
  import Font from './Font.html';
  import { store, theme } from '../stores';

  let chosenFontFace = $store.fontFace;

  function choose() {
    store.set($store.setFontFace(chosenFontFace));
  }
</script>
